import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

export default function Dashboard({ portsData, countriesData, loading }) {
  if (loading) {
    return (
      <div className="h-full flex items-center justify-center">
        <p className="text-lg">Loading data...</p>
      </div>
    );
  }

  const stats = [
    { title: 'Total Ports', value: portsData.length.toLocaleString(), label: 'Worldwide' },
    { title: 'EU ETS Enabled', value: portsData.filter(p => p.is_ets_enabled === 'true').length.toLocaleString(), label: 'Compliant Ports' },
    { title: 'Countries', value: countriesData.length.toLocaleString(), label: 'Total Coverage' },
    { title: 'Continents', value: '7', label: 'Global Reach' },
  ];

  return (
    <div className="p-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {stats.map((stat, index) => (
          <Card key={index} className="hover:shadow-md transition-shadow">
            <CardHeader className="pb-3">
              <CardDescription className="uppercase text-xs">{stat.title}</CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-4xl font-bold text-gray-900 mb-1">{stat.value}</p>
              <Badge variant="outline" className="mt-2">{stat.label}</Badge>
            </CardContent>
          </Card>
        ))}
      </div>

      <Card className="text-center">
        <CardHeader>
          <CardTitle className="text-2xl">Welcome to COEMS Test Utility</CardTitle>
          <CardDescription>
            Use the Port Checker to explore maritime ports worldwide with advanced filtering capabilities.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button size="lg">
            Go to Port Checker →
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
